import { useEffect } from "react";
import useAdminHistoryMonitoring from "../../hooks/monitoring/useAdminHistoryMonitoring";
import { Box } from "@mui/material";
import AdminHistoryGrid from "../../components/organismos/specials/AdminGrid";

/**
 * AdminMonitored
 *
 * Pagina que muestra el historial de acceso de los administradores.
 *
 * Utiliza el hook `useAdminHistoryMonitoring` para obtener el historial de
 * acceso de los administradores.
 *
 * El hook `useEffect` se utiliza para llamar a la funcion `visitedAllData` de
 * `useAdminHistoryMonitoring` cuando el componente se monta y cada vez que
 * cambia la paginacion.
 *
 * El componente `AdminHistoryGrid` se encarga de mostrar el historial de
 * acceso en una tabla.
 *
 * @returns {JSX.Element}
 */
const AdminMonitored = () => {
  const { pagination, visitedAllData } = useAdminHistoryMonitoring();

  useEffect(() => {
    visitedAllData();
  }, [pagination]);

  return (
    <Box>
      <AdminHistoryGrid />
    </Box>
  );
};

export default AdminMonitored;
